import { render, staticRenderFns } from "./Recalls.vue?vue&type=template&id=7241902e&scoped=true"
import script from "./Recalls.vue?vue&type=script&lang=js"
export * from "./Recalls.vue?vue&type=script&lang=js"
import style0 from "./Recalls.vue?vue&type=style&index=0&id=7241902e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7241902e",
  null
  
)

export default component.exports